import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="splash"
export default class extends Controller {
  connect() {
    console.log("Hello from app/javascript/controllers/splash_controller.js");
  }
}
